/* eslint-disable @typescript-eslint/ban-ts-comment */
import i18n, { InitOptions } from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

export const DEFAULT_NS = 'translation';
// export const DEFAULT_LNG = localStorage.getItem('lng') || undefined;

export async function configureI18n(
  bundles: {
    namespace?: string;
    bundles?: object[];
  }[] = [],
  { useLanguageDetector = true, useHttpBackend = false } = {}
) {
  if (useHttpBackend) {
    i18n.use(Backend);
  }

  i18n.use(initReactI18next);

  if (useLanguageDetector) {
    i18n.use(LanguageDetector);
  }
  const config: InitOptions = {
    fallbackLng: 'en',
    defaultNS: DEFAULT_NS,
    load: 'languageOnly',
    // @ts-ignore
    debug: import.meta.env.NX_DEBUG_I18N === 'true',
    interpolation: {
      escapeValue: false
    },
    // ...(DEFAULT_LNG && { lng: DEFAULT_LNG })
  };
  await i18n.init(config);

  bundles.forEach(({ namespace, bundles: packageBundle = [] } = {}) => {
    Object.entries(packageBundle).forEach(([language, bundle]) => {
      i18n.addResourceBundle(language, namespace || '', bundle);
    });
  });
}

export function t(key: any, namespace = DEFAULT_NS) {
  return i18n.t(key, { ns: namespace });
}

export async function changeLanguage(lng: string) {
  //save to store
  // localStorage.setItem('lng', lng);
  return i18n.changeLanguage(lng);
}

export default configureI18n;
